import type { UserBonusWalletResponse } from '@/interfaces/user';

import request from '../request';

export const getUserBonusWallet = async (): Promise<{
  data: UserBonusWalletResponse;
}> => {
  const response = await request({
    url: '/user/bonus_wallet_accounts',
  });
  return response;
};
